import { EnvConfigService } from '../../core/services/config-handler/config-handler.service';

export function configFactory() {
  return EnvConfigService.config;
}
